import type { Message, MessageAttachment } from '../services/chatService';

export interface ConversationMediaItem {
  type: 'image' | 'video';
  src: string;
  thumbnailSrc?: string;
  width?: number;
  height?: number;
  messageId: string;
  createdAt: string;
}

export const attachmentToMediaItem = (
  attachment: MessageAttachment,
  message: Pick<Message, '_id' | 'createdAt'>
): ConversationMediaItem => ({
  type: attachment.type,
  src: attachment.url,
  thumbnailSrc: attachment.thumbnailUrl,
  width: attachment.width,
  height: attachment.height,
  messageId: message._id,
  createdAt: message.createdAt,
});

export const collectConversationMedia = (messages: Message[]): ConversationMediaItem[] => {
  const items: ConversationMediaItem[] = [];

  for (const message of messages) {
    if (!message.attachments?.length) continue;
    for (const attachment of message.attachments) {
      items.push(attachmentToMediaItem(attachment, message));
    }
  }

  return items.sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
};

export const findConversationMediaIndex = (
  items: ConversationMediaItem[],
  messageId: string,
  src: string
): number => items.findIndex((item) => item.messageId === messageId && item.src === src);

export const toViewerItems = (items: ConversationMediaItem[]) =>
  items.map((item) => ({
    type: item.type,
    src: item.src,
    thumbnailSrc: item.thumbnailSrc,
    width: item.width,
    height: item.height,
  }));
